import type { ExtendedAuthContextType } from './types';

/**
 * 기본 AuthContext 값 정의
 */
export const defaultAuthContext: ExtendedAuthContextType = {
  state: {
    user: null,
    token: null,
    refreshToken: null,
    isAuthenticated: false,
    isLoading: true,
    error: null
  },
  login: async () => { console.warn('AuthProvider not initialized'); },
  register: async () => { console.warn('AuthProvider not initialized'); },
  logout: async () => { console.warn('AuthProvider not initialized'); },
  refreshAuth: async () => { console.warn('AuthProvider not initialized'); },
  clearError: () => { console.warn('AuthProvider not initialized'); },
  isAuthenticated: () => false,
  hasRole: () => false,
  fetchUserEmail: async () => { console.warn('AuthProvider not initialized'); return undefined; },
  startFreshAuth: () => { console.warn('AuthProvider not initialized'); },
  setAuthenticatedState: async () => { console.warn('AuthProvider not initialized'); },
  exchangeGoogleToken: async () => { console.warn('AuthProvider not initialized'); return { success: false }; },
  exchangeGoogleAuthCode: async () => { console.warn('AuthProvider not initialized'); return { success: false }; },
  exchangeKakaoAuthCode: async () => { console.warn('AuthProvider not initialized'); return { success: false }; },
};